import React, { memo } from 'react';

export const Modus = memo(({ data }) => {
    return (
        <div id="modus" className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>Was wird gespielt?</h2>
                </div>
                <p>
                    Bei uns werden in der Regel &quot;Mini Challenger&quot; gespielt - kleine Turniere, die zwar nach offiziellen Regeln gespielt werden, aber dennoch eher zwanglos sind. Bei uns steht der Spaß im Vordergrund. Die
                    verschiedenen Varianten werden hier erklärt.
                </p>
                <br/><br/>
                <div className="row">
                    {data && data.length > 0 ? (
                        data.map((d, i) => (
                            <div key={`${d.name}-${i}`} className="col-md-4">
                                <div className="modus-card">
                                    <div className="modus-card-icon">
                                        <img
                                            src={`./img/icons/${d.icon}`}
                                            alt={d.name}
                                            width="40"
                                            height="40"
                                            loading="lazy"
                                        />
                                    </div>
                                    <h3>{d.name}</h3>
                                    <p>{d.text}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-md-12">
                            <p>Keine Daten verfügbar</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

Modus.displayName = 'Modus';
